import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M13 8.837C11.1471 9.58702 9.1218 10 7 10C4.8782 10 2.85286 9.58702 1 8.837M9.66667 4.00004V2.66671C9.66667 1.93033 9.06971 1.33337 8.33333 1.33337H5.66667C4.93029 1.33337 4.33333 1.93033 4.33333 2.66671V4.00004M7 8.00004H7.00667M2.33333 13.3334H11.6667C12.403 13.3334 13 12.7364 13 12V5.33337C13 4.59699 12.403 4.00004 11.6667 4.00004H2.33333C1.59695 4.00004 1 4.59699 1 5.33337V12C1 12.7364 1.59695 13.3334 2.33333 13.3334Z" />
  </svg>
);
